import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from '@router/index';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { AuthInitializer } from '@features/authentication/components/AuthInitializer';
import { AppUpdateWatcher } from '@features/app-shell';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthInitializer>
          <AppRouter />
        </AuthInitializer>
        {/* Outside AuthInitializer: a stale login page is still a stale page. */}
        <AppUpdateWatcher />
        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
